@if (component) {
  @for (item of component.items; track item; let i = $index) {
    <div class="p-b-2 p-b-5-s cursor-pointer"
      [ngClass]="component.menuTitleFont || ''"
      [innerHTML]="i + 1 + '. ' + item.title"
      (click)="scrollToIndex(i)">
    </div>
  }
  @for (item of component.items; track item; let i = $index) {
    <div class="p-t-10"
      >
      <p [ngClass]="[component.contentTitleFont || '']"
        class="p-b-1"
        [attr.id]="'item_' + i">
        <span>{{ i + 1}}.</span>
        {{item.title}}
      </p>
      <p [ngClass]="component.contentFont || ''"
        *iCms="'content' of item">
      </p>
    </div>
  }
}
